// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-nav {
    margin-bottom: 24px;
    padding: 0 24px;
    border-bottom: 1px solid #f0f0f0;
}

.main-nav .ant-menu-item {
    padding: 0 20px;
}

.main-nav .ant-menu-item .anticon {
    margin-right: 8px;
}

/* Optional: Add a hover effect */
.main-nav .ant-menu-item:hover {
    color: #1890ff;
}`, "",{"version":3,"sources":["webpack://./src/components/Navigation/styles.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,iCAAiC;AACjC;IACI,cAAc;AAClB","sourcesContent":[".main-nav {\n    margin-bottom: 24px;\n    padding: 0 24px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.main-nav .ant-menu-item {\n    padding: 0 20px;\n}\n\n.main-nav .ant-menu-item .anticon {\n    margin-right: 8px;\n}\n\n/* Optional: Add a hover effect */\n.main-nav .ant-menu-item:hover {\n    color: #1890ff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
